import { __awaiter, __generator } from "tslib";
import { defineComponent, ref } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { ArrowLeftBold } from '@element-plus/icons';
import { taiwanLocation } from '@/utils/location';
import cyclingShapeHandler from '@/api-handler/cycling';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'FindBikeLane',
    components: {
        BaseLayout: BaseLayout,
        ArrowLeftBold: ArrowLeftBold,
    },
    setup: function () {
        var _this = this;
        var router = useRouter();
        var taiwanLocationList = taiwanLocation;
        var selectedLocation = ref('');
        var bikeLanesInfo = ref([]);
        var searchBikeLane = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, cyclingShapeHandler.getCyclingShape(selectedLocation.value)];
                    case 1:
                        res = _a.sent();
                        bikeLanesInfo.value = res.data;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var checkLaneMap = function (bikeLaneInfo) { return __awaiter(_this, void 0, void 0, function () {
            var RouteName, CyclingLength;
            return __generator(this, function (_a) {
                try {
                    RouteName = bikeLaneInfo.RouteName, CyclingLength = bikeLaneInfo.CyclingLength;
                    router.push({ name: 'FindBikeLaneMap', params: { city: selectedLocation.value, routeName: RouteName, distance: CyclingLength } });
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        }); };
        var getSelectedOption = function (option) {
            selectedLocation.value = option.value;
            searchBikeLane();
        };
        var goBack = function () {
            router.back();
        };
        return {
            taiwanLocationList: taiwanLocationList,
            bikeLanesInfo: bikeLanesInfo,
            getSelectedOption: getSelectedOption,
            checkLaneMap: checkLaneMap,
            goBack: goBack,
        };
    },
});
